import * as React from 'react'
import PropTypes from 'prop-types'
import { NumberInput } from '@resurs/midas-react'
import style from '../../shared/transactions.style'

export const ActionTypeInputField = ({
  id,
  validationClassName,
  value,
  onChange,
  index,
  suffix,
  disabled,
  styles,
  autoFocus,
  allowNegative,
}) => {
  return (
    <>
      <div style={style.inputContainer}>
        <div style={style.inputPosition}>
          <div className={validationClassName}>
            <NumberInput
              style={styles}
              id={id}
              key={id}
              value={value || ''}
              onChange={e => {
                onChange(e, index)
              }}
              disabled={disabled}
              autoFocus={!!autoFocus}
              skipValidation
              disableAutocomplete
              allowNegative={allowNegative}
            />
          </div>
        </div>
      </div>
      <span> {suffix}</span>
    </>
  )
}

ActionTypeInputField.propTypes = {
  id: PropTypes.string.isRequired,
  validationClassName: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  suffix: PropTypes.string,
  disabled: PropTypes.bool.isRequired,
  styles: PropTypes.string,
  autoFocus: PropTypes.bool,
  allowNegative: PropTypes.bool,
}

ActionTypeInputField.defaultProps = {
  suffix: '',
  styles: '',
  autoFocus: false,
  value: null,
  allowNegative: false,
}
